import { render } from "./ContractModelCreate.vue?vue&type=template&id=2cb51b4a"
import script from "./ContractModelCreate.vue?vue&type=script&lang=js"
export * from "./ContractModelCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__